import Header from './components/header';
// Code-splitting is automated for `routes` directory
import Home from './routes/home';
import Home2 from './routes/home2';

require('dotenv').config();

const App = (props) => {
  // console.log({ props });
  return (
    <div>
      <Header />
      {/* <Home /> */}
      <Home2 />
    </div>
  );
};

export default App;
